import { signal } from "@preact/signals-react";
export const weekStartsOn$ = signal(1);
//# sourceMappingURL=weekStartsOn.js.map